export default __webpack_public_path__ + "static/media/launcher-windows.35668869.jpg";